export default __webpack_public_path__ + "static/media/Mark-5-HUD-03.ed7e6593.jpg";